import { authorizedApi } from '../../utils/api';

export const getRxOrders = (token, paramString) => {
  return authorizedApi(token).get(`/rx/orders?${paramString}`);
};

export const getRxOrder = (id, token) => {
  return authorizedApi(token).get(`/rx/orders/${id}`);
};

export const createRxIdOnlyOrder = (data, token) => {
  return authorizedApi(token).post('/rx/orders/id-only', data);
};

export const getRxOffices = (token) => {
  return authorizedApi(token).get('/rx/offices');
};

export const rxLogout = (token) => {
  return authorizedApi(token).post('/rx/user/logout');
};

export const getRxOrderTypes = (token, officeId) => {
  return authorizedApi(token).get(`/rx/order-types?client_office_id=${officeId}`);
};

export const createRxFullOrder = (data, token) => {
  return authorizedApi(token).post('/rx/orders/full', data);
};

export const convertRxOrder = (id, data, token) => {
  return authorizedApi(token).post(`/rx/orders/${id}/convert`, data);
};
